import antdEnglish from "antd/lib/locale/en_US"
import messages from "../locales/en_US.json"

const EnglishLanguage = {
  messages: {
    ...messages,
  },
  antd: antdEnglish,
  locale: "en-US",
}

export default EnglishLanguage
